/* Amble Goods — JS compartido de las secciones "rd-*". Vanilla, sin librerías. */

function rdInitReveal() {
  var items = document.querySelectorAll('.rd-reveal:not(.rd-observado)');
  if (!items.length) return;

  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) {
      el.classList.add('rd-visible');
    });
    return;
  }

  var observer =
    window.__rdRevealObserver ||
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.getAttribute('data-rd-delay') || 0;
            setTimeout(function () {
              entry.target.classList.add('rd-visible');
            }, Number(delay));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

  window.__rdRevealObserver = observer;

  items.forEach(function (el) {
    el.classList.add('rd-observado');
    observer.observe(el);
  });
}

function rdInitGaleria() {
  document.querySelectorAll('[data-rd-galeria]').forEach(function (galeria) {
    if (galeria.dataset.rdInit) return;
    galeria.dataset.rdInit = 'true';

    var principalImg = galeria.querySelector('[data-rd-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-rd-galeria-mini]');

    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.getAttribute('data-rd-galeria-mini');
        if (principalImg && full) {
          principalImg.src = full;
        }
        minis.forEach(function (m) {
          m.classList.remove('rd-activo');
        });
        mini.classList.add('rd-activo');
      });
    });
  });
}

function rdInitAcordeon() {
  document.querySelectorAll('[data-rd-acordeon-item]').forEach(function (item) {
    if (item.dataset.rdInit) return;
    item.dataset.rdInit = 'true';

    var header = item.querySelector('[data-rd-acordeon-boton]');
    if (!header) return;

    header.addEventListener('click', function () {
      var estabaAbierto = item.classList.contains('rd-abierto');
      item.parentElement.querySelectorAll('[data-rd-acordeon-item]').forEach(function (otro) {
        otro.classList.remove('rd-abierto');
      });
      if (!estabaAbierto) {
        item.classList.add('rd-abierto');
      }
    });
  });
}

function rdInitVariantes() {
  document.querySelectorAll('[data-rd-producto-form]').forEach(function (form) {
    if (form.dataset.rdInit) return;
    form.dataset.rdInit = 'true';

    var variantsDataEl = form.querySelector('[data-rd-variantes-json]');
    if (!variantsDataEl) return;

    var variants;
    try {
      variants = JSON.parse(variantsDataEl.textContent);
    } catch (e) {
      return;
    }

    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-rd-boton-comprar]');
    var precioEl = document.querySelector('[data-rd-precio-actual]');
    var precioAnteriorEl = document.querySelector('[data-rd-precio-anterior]');
    var stockEl = document.querySelector('[data-rd-stock]');
    var pildoras = form.querySelectorAll('[data-rd-pildora]');

    function opcionesSeleccionadas() {
      var seleccion = {};
      form.querySelectorAll('[data-rd-opcion-grupo]').forEach(function (grupo) {
        var nombre = grupo.getAttribute('data-rd-opcion-grupo');
        var activo = grupo.querySelector('.rd-activo');
        if (activo) {
          seleccion[nombre] = activo.getAttribute('data-value');
        }
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = opcionesSeleccionadas();
      return variants.find(function (v) {
        return Object.keys(seleccion).every(function (nombre) {
          return v.selected_options[nombre] === seleccion[nombre];
        });
      });
    }

    function formatearDinero(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es-ES', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR',
      });
    }

    function actualizarGaleria(variante) {
      if (!variante.featured_image) return;
      var galeria = document.querySelector('[data-rd-galeria]');
      if (!galeria) return;
      var principal = galeria.querySelector('[data-rd-galeria-principal]');
      if (principal) principal.src = variante.featured_image;

      var minis = galeria.querySelectorAll('[data-rd-galeria-mini]');
      var encontrada = false;
      minis.forEach(function (mini) {
        var coincide = mini.getAttribute('data-rd-galeria-mini') === variante.featured_image;
        mini.classList.toggle('rd-activo', coincide);
        if (coincide) encontrada = true;
      });
      if (!encontrada) {
        minis.forEach(function (mini) {
          mini.classList.remove('rd-activo');
        });
      }
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-texto-no-disponible') || addBtn.textContent;
        }
        return;
      }

      if (idInput) idInput.value = variante.id;
      actualizarGaleria(variante);

      if (precioEl) precioEl.textContent = formatearDinero(variante.price);
      if (precioAnteriorEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAnteriorEl.textContent = formatearDinero(variante.compare_at_price);
          precioAnteriorEl.hidden = false;
        } else {
          precioAnteriorEl.hidden = true;
        }
      }

      if (addBtn) {
        if (variante.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-texto-comprar') || addBtn.textContent;
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-texto-agotado') || addBtn.textContent;
        }
      }

      if (stockEl) {
        stockEl.classList.toggle('rd-agotado', !variante.available);
        var texto = variante.available
          ? stockEl.getAttribute('data-texto-disponible')
          : stockEl.getAttribute('data-texto-agotado');
        var span = stockEl.querySelector('span:last-child');
        if (span && texto) span.textContent = texto;
      }

      form.querySelectorAll('[data-rd-opcion-grupo]').forEach(function (grupo) {
        var valorActualEl = grupo.parentElement.querySelector('[data-rd-valor-actual]');
        var activo = grupo.querySelector('.rd-activo');
        if (valorActualEl && activo) {
          valorActualEl.textContent = activo.getAttribute('data-value');
        }
      });
    }

    pildoras.forEach(function (pildora) {
      pildora.addEventListener('click', function () {
        if (pildora.disabled) return;
        var grupo = pildora.closest('[data-rd-opcion-grupo]');
        grupo.querySelectorAll('[data-rd-pildora]').forEach(function (p) {
          p.classList.remove('rd-activo');
        });
        pildora.classList.add('rd-activo');
        actualizar();
      });
    });

    function seleccionarPorImagen(mini) {
      var src = mini.getAttribute('data-rd-galeria-mini');
      var variante = variants.find(function (v) {
        return v.featured_image === src;
      });
      if (!variante) return;
      Object.keys(variante.selected_options).forEach(function (nombre) {
        var grupo = form.querySelector('[data-rd-opcion-grupo="' + nombre + '"]');
        if (!grupo) return;
        grupo.querySelectorAll('[data-rd-pildora]').forEach(function (p) {
          p.classList.toggle('rd-activo', p.getAttribute('data-value') === variante.selected_options[nombre]);
        });
      });
      actualizar();
    }

    document.querySelectorAll('[data-rd-galeria-mini]').forEach(function (mini) {
      mini.addEventListener('click', function () {
        seleccionarPorImagen(mini);
      });
    });

    actualizar();
  });
}

function rdInitTiltHero() {
  var marco = document.querySelector('[data-rd-tilt]');
  if (!marco || marco.dataset.rdInit) return;
  marco.dataset.rdInit = 'true';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esTactil = window.matchMedia('(hover: none)').matches;
  if (reduceMotion || esTactil) return;

  var maxGrados = 7;

  marco.addEventListener('mousemove', function (e) {
    var rect = marco.getBoundingClientRect();
    var x = (e.clientX - rect.left) / rect.width - 0.5;
    var y = (e.clientY - rect.top) / rect.height - 0.5;
    var rotY = (x * maxGrados * 2).toFixed(2);
    var rotX = (y * -maxGrados * 2).toFixed(2);
    marco.style.transform = 'rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg)';
  });

  marco.addEventListener('mouseleave', function () {
    marco.style.transform = 'rotateX(0deg) rotateY(0deg)';
  });
}

function rdInitTodo() {
  rdInitReveal();
  rdInitGaleria();
  rdInitAcordeon();
  rdInitVariantes();
  rdInitTiltHero();
}

document.addEventListener('DOMContentLoaded', rdInitTodo);
document.addEventListener('shopify:section:load', rdInitTodo);
